export const AUDIT_TYPE_VALUES = {
  INITIAL: '최초',
  SURVEILLANCE: '사후',
  RENEWAL: '갱신',
  MIXED: '혼합',
  TRANSFER_REVIEW: '전환심사',
  SPECIAL: '특별',
  REASSESSMENT: '재심사',
  TRANSFER_SURVEILLANCE: '전환사후',
  TRANSFER_RENEWAL: '전환갱신'
}

export const CANONICAL_AUDIT_TYPE_OPTIONS = [
  { value: AUDIT_TYPE_VALUES.INITIAL, label: '최초' },
  { value: AUDIT_TYPE_VALUES.SURVEILLANCE, label: '사후' },
  { value: AUDIT_TYPE_VALUES.RENEWAL, label: '갱신' },
  { value: AUDIT_TYPE_VALUES.MIXED, label: '혼합' },
  { value: AUDIT_TYPE_VALUES.TRANSFER_REVIEW, label: '전환인증 사전검토' },
  { value: AUDIT_TYPE_VALUES.SPECIAL, label: '특별' },
  { value: AUDIT_TYPE_VALUES.REASSESSMENT, label: '재심사' }
]

export const LEGACY_TRANSFER_AUDIT_TYPE_OPTIONS = [
  { value: AUDIT_TYPE_VALUES.TRANSFER_SURVEILLANCE, label: '전환사후', legacy: true },
  { value: AUDIT_TYPE_VALUES.TRANSFER_RENEWAL, label: '전환갱신', legacy: true }
]

const LEGACY_LABEL_MAP = {
  initial: AUDIT_TYPE_VALUES.INITIAL,
  surveillance: AUDIT_TYPE_VALUES.SURVEILLANCE,
  renewal: AUDIT_TYPE_VALUES.RENEWAL,
  mixed: AUDIT_TYPE_VALUES.MIXED,
  transfer: AUDIT_TYPE_VALUES.TRANSFER_REVIEW,
  special: AUDIT_TYPE_VALUES.SPECIAL,
  reassessment: AUDIT_TYPE_VALUES.REASSESSMENT,
  신규: AUDIT_TYPE_VALUES.INITIAL,
  전환: AUDIT_TYPE_VALUES.TRANSFER_REVIEW
}

export function normalizeAuditType(value) {
  const text = String(value || '').trim()
  return LEGACY_LABEL_MAP[text] || text
}

export function auditTypeLabel(value) {
  const normalized = normalizeAuditType(value)
  const option = [...CANONICAL_AUDIT_TYPE_OPTIONS, ...LEGACY_TRANSFER_AUDIT_TYPE_OPTIONS]
    .find((item) => item.value === normalized)
  return option ? option.label : normalized
}

// 보고서 지면(심사계획서·심사 결과 보고서)의 제목 괄호 안에 인쇄되는 심사유형 문구.
// 화면마다 삼항식으로 복제돼 있었고 그중 어느 것도 '혼합' 을 다루지 않아
// 혼합심사 보고서가 '갱신심사'로 인쇄됐다.
const AUDIT_HEADING_LABELS = {
  [AUDIT_TYPE_VALUES.SURVEILLANCE]: '사후심사',
  [AUDIT_TYPE_VALUES.RENEWAL]: '갱신심사',
  [AUDIT_TYPE_VALUES.MIXED]: '혼합심사',
  [AUDIT_TYPE_VALUES.TRANSFER_REVIEW]: '전환심사',
  [AUDIT_TYPE_VALUES.TRANSFER_SURVEILLANCE]: '전환사후 심사',
  [AUDIT_TYPE_VALUES.TRANSFER_RENEWAL]: '전환갱신 심사',
  [AUDIT_TYPE_VALUES.SPECIAL]: '특별 심사',
  [AUDIT_TYPE_VALUES.REASSESSMENT]: '재심사 심사'
}

// '최초' 문구는 한때 지면마다 달랐다 — 심사계획서 '최초2단계 심사',
//   심사 결과 보고서 '최초 심사'(조회·작성) / '최초2단계 심사'(수정), 표지 '최초 2단계 심사'.
//   2026-09-06 표지 형식('최초 2단계 심사')으로 통일했다. initialLabel 은 남겨두되
//   호출부가 넘기지 않는 것이 정상이다.
// fallback — 값이 없거나(로딩 중) 알 수 없는 유형. 기존 지면 동작을 그대로 둔다.
export function auditHeadingLabel(
  auditType,
  { initialLabel = '최초 2단계 심사', fallback = '갱신심사' } = {}
) {
  const normalized = normalizeAuditType(auditType)
  if (normalized === AUDIT_TYPE_VALUES.INITIAL) return initialLabel
  return AUDIT_HEADING_LABELS[normalized] || fallback
}

export function getAuditTypeOptions() {
  return CANONICAL_AUDIT_TYPE_OPTIONS
}

export function isLegacyTransferAuditType(value) {
  const normalized = normalizeAuditType(value)
  return LEGACY_TRANSFER_AUDIT_TYPE_OPTIONS.some((option) => option.value === normalized)
}

export function isStandardLevelAuditType(type) {
  return [AUDIT_TYPE_VALUES.INITIAL, AUDIT_TYPE_VALUES.SURVEILLANCE, AUDIT_TYPE_VALUES.RENEWAL].includes(normalizeAuditType(type))
}

export function shouldUseMixedAuditType(details = []) {
  const types = new Set(
    (Array.isArray(details) ? details : [])
      .map((detail) => normalizeAuditType(detail.audit_type || detail.auditType))
      .filter(isStandardLevelAuditType)
  )
  return types.size > 1
}

export function deriveHeaderAuditType({ currentType, details = [] } = {}) {
  if (shouldUseMixedAuditType(details)) return AUDIT_TYPE_VALUES.MIXED
  return normalizeAuditType(currentType)
}
